var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{attrs:{"variant":"link","disabled":_vm.busy},on:{"click":_vm.clone}},[(_vm.busy)?_c('font-awesome-icon',{staticClass:"fa-spin",attrs:{"icon":"fa-solid fa-spinner"}}):_c('font-awesome-icon',{attrs:{"icon":"fa-light fa-clone"}}),_c('span',[_vm._v("Clone Order")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }